<template>
  <div class="transmitRemoteEvento" v-if="item._id !== ''">
    <div class="remoteEventHeader">
      <div class="remoteEventTitle">
        <small class="remoteEventDate" v-if="item.dataHora !== null && item.dataHora !== ''">
          {{ String(item.dataDia).padStart(2,'0') }}/{{ String(item.dataMes).padStart(2,'0') }}/{{ item.dataAno }}
          {{ String(item.dataHora).padStart(2,'0') }}:{{ String(item.dataMinuto).padStart(2,'0') }}
        </small>
        <h5>{{ item.nome }}</h5>
        <small class="remoteHeaderMessage">
          {{ mensagem == '' ? "Inicie a transmissão" : mensagem }}
        </small>
        <div class="remoteHeaderActions">
          <button
            type="button"
            class="btn btn-outline-dark btn-sm"
            @click="abrirTransmissaoLocal()"
            :disabled="loading"
          >
            Local
          </button>
          <div class="remoteStatusDropdown">
            <button
              type="button"
              class="btn btn-sm remoteStatusButton"
              :class="statusButtonClass(item.situacao)"
              @click="statusMenuOpen = !statusMenuOpen"
            >
              {{ situacaoLabel(item.situacao) }}
            </button>
            <div class="remoteStatusMenu" v-if="statusMenuOpen">
              <button
                type="button"
                v-for="status in statusMenuOptions"
                :key="status.value"
                class="remoteStatusOption"
                @click="alterarSituacaoEvento(status.value)"
                :disabled="loading"
              >
                {{ status.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="remoteChannelToolbar">
      <div class="remoteChannelBar">
        <div
          class="remoteChannel"
          v-for="keyCanal in channelKeys"
          :key="keyCanal"
          :class="{
            remoteChannelLive: canais[keyCanal].status,
            remoteChannelSelected: isChannelSelected(keyCanal, 'status'),
            remoteChannelDisabled: !isChannelEnabled(keyCanal),
          }"
        >
          <button
            type="button"
            class="remoteChannelButton"
            @click="cliqueCanal(keyCanal, $event)"
            :disabled="!isChannelEnabled(keyCanal) || loading"
            :title="canais[keyCanal].status ? 'Parar canal ' + keyCanal : 'Iniciar canal ' + keyCanal"
          >
            {{ keyCanal }}
          </button>
          <button
            type="button"
            class="remoteServerButton"
            :class="{ remoteServerSelected: isChannelSelected(keyCanal, 'servidor') }"
            @click="
              $event.shiftKey == false &&
              $event.ctrlKey == false &&
              $event.metaKey == false
                ? editarCanal(keyCanal)
                : selecionarCanal(keyCanal, $event, 'servidor')
            "
            :disabled="loading || !isChannelConfigurable(keyCanal)"
          >
            {{ servidorNome(canais[keyCanal].servidor) }}
          </button>
        </div>

        <button
          type="button"
          class="remoteChannelAdd"
          v-if="canAddChannel"
          @click="adicionarCanalRemoto()"
          :disabled="loading"
          title="Adicionar canal"
          aria-label="Adicionar canal"
        >
          +
        </button>
      </div>
    </div>

    <hr class="remoteSectionDivider" />

    <div class="remoteSourceLayout">
      <div class="remoteFavoritesPanel text-left">
        <div class="d-flex justify-content-between align-items-center">
          <h6>Sources</h6>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="abrirDialogSource()"
          >
            Add
          </button>
        </div>

        <div class="remoteFavoriteEmpty" v-if="remoteSources.length == 0">
          <small class="text-secondary">Nenhum source favorito neste evento.</small>
        </div>

        <button
          type="button"
          class="remoteFavoriteCard"
          v-for="favorite in remoteSources"
          :key="favorite.sourceKey + '_' + favorite.videoId + '_' + favorite.audioId"
          v-bind:class="{
            remoteFavoriteActive: isFavoriteSelected(favorite),
            remoteFavoriteVisible: isFavoritePreviewVisible(favorite),
            remoteFavoriteTransmitting: isFavoriteTransmitting(favorite),
          }"
          @click="aplicarFavorito(favorite, $event)"
          :disabled="loading"
        >
          <strong>
            <svg
              v-if="isFavoriteTransmitting(favorite)"
              class="remoteTransmitIcon"
              viewBox="0 0 16 16"
              width="13"
              height="13"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M8 2.5a5.5 5.5 0 0 0-3.89 9.39.75.75 0 0 1-1.06 1.06A7 7 0 1 1 8 15a.75.75 0 0 1 0-1.5A5.5 5.5 0 1 0 8 2.5zm0 3A2.5 2.5 0 1 0 8 10.5 2.5 2.5 0 0 0 8 5.5z"
              />
            </svg>
            {{ favorite.sourceNome || favorite.hostname || favorite.sourceKey }}
          </strong>
          <span>{{ favorite.videoLabel || favorite.videoId }}</span>
          <small v-if="favorite.audioId">{{ favorite.audioLabel || favorite.audioId }}</small>
          <small v-if="!favorite.audioId">Sem audio</small>
        </button>
      </div>

      <div class="remotePreviewPanel">
        <div class="remotePreviewEmpty" v-if="previewTiles.length === 0">
          <h6>Selecione um source favorito</h6>
          <small>Use Add para adicionar novas fontes ao evento.</small>
        </div>

        <div class="remotePreviewPlayer" v-if="previewTiles.length > 0" ref="remotePreviewPlayer">
          <div
            v-for="tile in previewTiles"
            :key="tile.key"
            class="remotePreviewPendingTile"
            :style="{ order: previewTileOrder(tile.key) }"
            v-bind:class="{
              remotePreviewPendingTileFull:
                visiblePreviewKeys.length == 0 && previewTiles.length == 1,
              remotePreviewHidden: tile.type !== 'pending',
            }"
          >
            <div class="remotePreviewTileHeader remoteSelectedSourceHeader text-left">
              <div class="remotePreviewTitle">
                <strong>{{ tile.sourceNome || tile.hostname || tile.sourceKey }}</strong>
                <small>
                  {{ tile.videoLabel || tile.deviceId }}
                  <span v-if="tile.audioId">
                    / {{ tile.audioLabel || tile.audioId }}
                  </span>
                  <span v-if="!tile.audioId"> / Sem audio</span>
                </small>
              </div>
              <div class="remotePreviewTileActions">
                <button
                  type="button"
                  class="btn btn-success btn-sm remoteTransmitPreviewButton"
                  @click="transmitirPreviewPendente(tile)"
                  :disabled="
                    loading ||
                    isActiveTransmissionSelection(
                      tile.sourceKey,
                      tile.deviceId,
                      tile.audioId,
                    )
                  "
                  title="Transmitir este source"
                  aria-label="Transmitir este source"
                >
                  Transmitir
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm remoteIconButton"
                  @click="removerFavoritoPendente(tile)"
                  :disabled="loading || !isPendingFavorite(tile) || isActiveTransmissionSelection(tile.sourceKey, tile.deviceId, tile.audioId || '')"
                  title="Remover favorito"
                  aria-label="Remover favorito"
                >
                  <svg
                    viewBox="0 0 16 16"
                    width="14"
                    height="14"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      fill="currentColor"
                      d="M6.5 1.5a1 1 0 0 0-.9.55L5.12 3H2.75a.75.75 0 0 0 0 1.5h.3l.58 8.13A2 2 0 0 0 5.62 14.5h4.76a2 2 0 0 0 1.99-1.87l.58-8.13h.3a.75.75 0 0 0 0-1.5h-2.37l-.48-.95a1 1 0 0 0-.9-.55h-3zM6.8 3l.25-.5h1.9l.25.5H6.8zm-2.25 1.5h6.9l-.57 8.02a.5.5 0 0 1-.5.48H5.62a.5.5 0 0 1-.5-.48L4.55 4.5zm1.7 1.5A.75.75 0 0 1 7 6.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 6.25 6zm3.5 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 9.75 6z"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div class="remotePreviewWaiting">
              <button
                type="button"
                class="btn btn-primary btn-sm remotePreviewStartButton"
                @click="solicitarPreviewPendente(tile)"
                :disabled="loading || previewLoading"
              >
                {{ previewLoading && isPendingSelected(tile) ? "Carregando..." : "Preview" }}
              </button>
              <small>Carregue o preview somente quando precisar visualizar este source.</small>
            </div>
          </div>
          <div
            v-for="tile in previewTiles"
            :key="'preview_' + tile.key"
            class="remotePreviewTile"
            :style="{ order: previewTileOrder(tile.key) }"
            v-bind:class="{ remotePreviewHidden: tile.type !== 'preview' || !isPreviewVisible(tile.key) }"
          >
            <div class="remotePreviewTileHeader text-left">
              <div class="remotePreviewTitle">
                <strong>{{ tile.sourceNome || tile.hostname || tile.sourceKey }}</strong>
                <small>
                  {{ tile.videoLabel || tile.deviceId }}
                  <span v-if="tile.audioId">
                    / {{ tile.audioLabel || tile.audioId }}
                  </span>
                </small>
              </div>
              <div class="remotePreviewTileActions">
                <button
                  type="button"
                  class="btn btn-success btn-sm remoteTransmitPreviewButton"
                  @click="transmitirPreview(tile)"
                  :disabled="loading || isPreviewTransmitting(tile)"
                  title="Transmitir este source"
                  aria-label="Transmitir este source"
                >
                  Transmitir
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm remoteIconButton"
                  @click="recarregarPreview(tile)"
                  title="Atualizar preview"
                  aria-label="Atualizar preview"
                >
                  <svg
                    viewBox="0 0 16 16"
                    width="14"
                    height="14"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      fill="currentColor"
                      d="M8 3a5 5 0 1 1-4.55 2.93.75.75 0 1 1 1.37.61A3.5 3.5 0 1 0 8 4.5H6.56l.72.72a.75.75 0 1 1-1.06 1.06L4.22 4.28a.75.75 0 0 1 0-1.06l2-2a.75.75 0 1 1 1.06 1.06L6.56 3H8z"
                    />
                  </svg>
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm remoteIconButton"
                  @click="removerFavoritoPreview(tile)"
                  :disabled="loading || !isPreviewFavorite(tile) || isPreviewTransmitting(tile)"
                  title="Remover favorito"
                  aria-label="Remover favorito"
                >
                  <svg
                    viewBox="0 0 16 16"
                    width="14"
                    height="14"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      fill="currentColor"
                      d="M6.5 1.5a1 1 0 0 0-.9.55L5.12 3H2.75a.75.75 0 0 0 0 1.5h.3l.58 8.13A2 2 0 0 0 5.62 14.5h4.76a2 2 0 0 0 1.99-1.87l.58-8.13h.3a.75.75 0 0 0 0-1.5h-2.37l-.48-.95a1 1 0 0 0-.9-.55h-3zM6.8 3l.25-.5h1.9l.25.5H6.8zm-2.25 1.5h6.9l-.57 8.02a.5.5 0 0 1-.5.48H5.62a.5.5 0 0 1-.5-.48L4.55 4.5zm1.7 1.5A.75.75 0 0 1 7 6.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 6.25 6zm3.5 0a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 9.75 6z"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <iframe
              :src="
                '/view/' +
                tile.eventoId +
                '?view=clean&canal=0&preview=1&_r=' +
                (tile.reloadToken || 0)
              "
              frameborder="0"
              scrolling="no"
              allow="autoplay; fullscreen; picture-in-picture"
              :style="{ height: previewFrameHeight + 'px' }"
              @load="atualizarPreviewFrameHeight"
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <hr class="remoteSectionDivider" />

    <div class="remoteBottomActions">
      <div
        class="remotePlayerChannel"
        v-bind:class="{ remotePlayerChannelExtra: !isEventChannel(keyCanal) }"
        v-for="keyCanal in channelKeys"
        :key="'player_' + keyCanal"
      >
        <button
          type="button"
          class="remotePlayerChannelButton"
          @click="cliquePlayerCanal(keyCanal, $event)"
          :title="'Abrir player do canal ' + keyCanal"
        >
          {{ keyCanal }}
        </button>
        <button
          type="button"
          class="remotePlayerChannelLabel"
          @click="cliquePlayerCanal(keyCanal, $event)"
          :title="'Abrir player do canal ' + keyCanal"
        >
          Player
        </button>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalSourceRemoto"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Adicionar source</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-left">
            <div class="row">
              <div class="col-md-4">
                <label><small>Source</small></label>
                <select class="form-control" v-model="dialogSourceKey" @change="onDialogSourceChange">
                  <option value="">Selecione...</option>
                  <option v-for="source in sourcesOrdered" :key="source.key" :value="source.key">
                    {{ source.nome || source.hostname || source.key }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <label><small>Video</small></label>
                <select class="form-control" v-model="dialogDeviceId" @change="aplicarDialogAudioVinculado">
                  <option value="">Selecione...</option>
                  <option
                    v-for="device in dialogVideoDevices"
                    :key="device.id + '_' + device.label"
                    :value="device.id"
                  >
                    {{ device.label || device.id }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <label><small>Audio</small></label>
                <select class="form-control" v-model="dialogAudioId">
                  <option value="">Sem audio</option>
                  <option
                    v-for="device in dialogAudioDevices"
                    :key="device.id + '_' + device.label"
                    :value="device.id"
                  >
                    {{ device.label || device.id }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="adicionarSourceDialog()"
              :disabled="dialogSourceKey == '' || dialogDeviceId == ''"
            >
              Adicionar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalCanalRemoto"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Canal {{ canalEdicao }}</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <button
              type="button"
              class="btn btn-sm remoteServerOption"
              v-for="(servidor, keyServidor) in servidoresTipo"
              :key="keyServidor"
              :class="{
                'btn-primary': canalEdicao !== '' && canais[canalEdicao].servidor == keyServidor,
                'btn-outline-primary': canalEdicao === '' || canais[canalEdicao].servidor !== keyServidor,
              }"
              @click="alterarCanalServidor(keyServidor)"
              data-dismiss="modal"
            >
              {{ servidor.nome }}
            </button>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { io } from "socket.io-client";
import { api } from "@/services/api.js";

export default {
  name: "TransmitRemoteEvento",
  methods: {
    retornaSite() {
      return this.$site;
    },
    socketBaseUrl() {
      var apiUrl = process.env.VUE_APP_URL_API || "";

      if (apiUrl.endsWith("/api")) {
        apiUrl = apiUrl.substring(0, apiUrl.length - 4);
      }

      return apiUrl;
    },
    async carregarItem(id) {
      const response = await api.get("/evento/" + id);
      api.valid(response.data, this.$router);

      if (response.data.itens.length > 0) {
        const itemEdit = response.data.itens[0];
        this.item = {
          _id: itemEdit._id,
          nome: itemEdit.nome,
          servidor: itemEdit.servidor,
          servidorTipo: itemEdit.servidorTipo || "ms",
          situacao: itemEdit.situacao,
          canais: itemEdit.canais || 1,
          remoteSources: itemEdit.remoteSources || [],
          dataDia: itemEdit.dataDia || "",
          dataMes: itemEdit.dataMes || "",
          dataAno: itemEdit.dataAno || "",
          dataHora: itemEdit.dataHora !== undefined ? itemEdit.dataHora : "",
          dataMinuto: itemEdit.dataMinuto !== undefined ? itemEdit.dataMinuto : "",
        };

        this.inicializarCanais(itemEdit);
        this.channelDisplayCount = this.defaultChannelDisplayCount(itemEdit);
        this.conectarSourceInicial();
        document.title = "TR Remote: " + itemEdit.nome;
      }
    },
    async carregarSources() {
      const response = await api.get("/source?_limit=1000&_page=1");
      api.valid(response.data, this.$router);

      this.sources = response.data.itens || [];
    },
    inicializarCanais(itemEdit) {
      const servidorPadrao = this.defaultServerKey(itemEdit);
      this.canais = {};
      const maxCanal = this.maxConfiguredChannel(itemEdit);

      for (var indiceCanal = 0; indiceCanal <= maxCanal; indiceCanal++) {
        const keyCanal = indiceCanal.toString();
        this.$set(this.canais, keyCanal, {
          canal: keyCanal,
          servidor: servidorPadrao,
          status: false,
        });

        if (itemEdit.transmissaoCanais && itemEdit.transmissaoCanais[keyCanal]) {
          const servidor = itemEdit.transmissaoCanais[keyCanal].servidor;
          if (servidor && this.$global.servidores_sip()[servidor]) {
            this.canais[keyCanal].servidor = servidor;
          }
        }
      }
    },
    maxConfiguredChannel(itemEdit) {
      const configuredChannels = Object.keys((itemEdit && itemEdit.transmissaoCanais) || {})
        .map((key) => parseInt(key))
        .filter((value) => !Number.isNaN(value));

      const maxConfigured = configuredChannels.length > 0 ? Math.max(...configuredChannels) : 0;
      const totalChannels = parseInt((itemEdit && itemEdit.canais) || 1) || 1;

      return Math.max(3, totalChannels, maxConfigured);
    },
    defaultServerKey(itemEdit) {
      const eventoServer = (itemEdit.servidorTipo || "ms") + "_" + itemEdit.servidor;

      if (eventoServer.startsWith("ms_") && this.$global.servidores_sip()[eventoServer]) {
        return eventoServer;
      }

      if (process.env.VUE_APP_SERVIDOR_PADRAO) {
        return process.env.VUE_APP_SERVIDOR_PADRAO;
      }

      const servidores = this.$global.servidores_sip_array().filter(function (item) {
        return item.id.startsWith("ms_") && item.router == false;
      });

      return servidores.length > 0 ? servidores[0].id : "";
    },
    defaultChannelDisplayCount(itemEdit) {
      return Math.max(3, parseInt((itemEdit && itemEdit.canais) || 1));
    },
    ensureChannelVisible(canal) {
      const channelNumber = parseInt(canal);

      if (Number.isNaN(channelNumber)) {
        return;
      }

      this.ensureChannelExists(channelNumber);
      this.channelDisplayCount = Math.max(this.channelDisplayMax, channelNumber);
    },
    ensureChannelExists(canal) {
      const channelNumber = parseInt(canal);

      if (Number.isNaN(channelNumber) || channelNumber < 0) {
        return;
      }

      const servidorPadrao = this.defaultServerKey(this.item);

      for (let indiceCanal = 0; indiceCanal <= channelNumber; indiceCanal++) {
        const keyCanal = indiceCanal.toString();

        if (!this.canais[keyCanal]) {
          this.$set(this.canais, keyCanal, {
            canal: keyCanal,
            servidor: servidorPadrao,
            status: false,
          });
        }
      }
    },
    onSourceChange() {
      this.sourceSelectionTouched = true;
      this.deviceId = "";
      this.audioId = "";
      this.connected = false;

      if (this.videoDevices.length == 1) {
        this.deviceId = this.videoDevices[0].id;
      }

      this.aplicarAudioVinculado();
      this.conectarSocket();
    },
    conectarSocket() {
      this.fecharSocket();

      if (!this.sourceKey) {
        return;
      }

      const token = localStorage.getItem("ckd");
      this.socket = io(this.socketBaseUrl(), {
        auth: {
          role: "manager",
          token,
          sourceKey: this.sourceKey,
        },
        transports: ["websocket", "polling"],
      });

      this.socket.on("connect_error", (err) => {
        this.connected = false;
        this.mensagem = err.message;
      });

      this.socket.on("source:connection", (payload) => {
        this.connected = payload && payload.connected == true;
        this.aplicarEstadoTransmissaoRemota(payload || {});
        if (this.connected && this.previewPending) {
          this.previewPending = false;
          this.iniciarPreview();
        }
        if (this.connected && this.transmitPending) {
          this.transmitPending = false;
          this.iniciarTransmissao(this.channelKeysForSourceSwitch(), { forceCanalZero: true });
        }
      });

      this.socket.on("source:transmit:status", (payload) => {
        this.onTransmitStatus(payload || {});
      });

      this.socket.on("source:transmit:state", (payload) => {
        this.aplicarEstadoTransmissaoRemota(payload || {});
      });

      this.socket.on("source:preview:status", (payload) => {
        this.onPreviewStatus(payload || {});
      });

      this.socket.emit("source:transmit:state:request", {
        eventoId: this.item._id,
      });
    },
    fecharSocket() {
      if (this.socket) {
        try {
          this.socket.disconnect();
        } catch (e) {
          console.log(e);
        }
      }

      this.socket = null;
    },
    aplicarAudioVinculado() {
      const link = (this.selectedSource.deviceAudioLinks || []).find((item) => {
        return item.videoId == this.deviceId;
      });

      this.audioId = link ? link.audioId : "";
    },
    abrirDialogSource() {
      this.dialogSourceKey = "";
      this.dialogDeviceId = "";
      this.dialogAudioId = "";
      this.carregarSources();
      window.$("#modalSourceRemoto").modal("show");
    },
    onDialogSourceChange() {
      this.dialogDeviceId = "";
      this.dialogAudioId = "";

      if (this.dialogVideoDevices.length == 1) {
        this.dialogDeviceId = this.dialogVideoDevices[0].id;
      }

      this.aplicarDialogAudioVinculado();
    },
    aplicarDialogAudioVinculado() {
      const link = (this.dialogSelectedSource.deviceAudioLinks || []).find((item) => {
        return item.videoId == this.dialogDeviceId;
      });

      this.dialogAudioId = link ? link.audioId : "";
    },
    conectarSourceInicial() {
      if (this.sourceKey !== "" || this.remoteSources.length == 0) {
        return;
      }

      const favorite = this.remoteSources[0];
      this.sourceKey = favorite.sourceKey;
      this.deviceId = favorite.videoId;
      this.audioId = favorite.audioId || "";
      this.connected = false;
      this.conectarSocket();
    },
    async adicionarSourceDialog() {
      const selectedBefore = {
        sourceKey: this.sourceKey,
        deviceId: this.deviceId,
        audioId: this.audioId,
      };
      const sourceBeforeTouched = this.sourceSelectionTouched;

      this.sourceKey = this.dialogSourceKey;
      this.deviceId = this.dialogDeviceId;
      this.audioId = this.dialogAudioId;
      const saved = await this.salvarFavorito(true);

      if (saved) {
        this.sourceKey = selectedBefore.sourceKey;
        this.deviceId = selectedBefore.deviceId;
        this.audioId = selectedBefore.audioId;
        this.sourceSelectionTouched = sourceBeforeTouched;
      }

      window.$("#modalSourceRemoto").modal("hide");
    },
    aplicarFavorito(favorite, event) {
      const multiSelect = event && (event.ctrlKey || event.metaKey || event.shiftKey);
      const previousSourceKey = this.sourceKey;
      const previewKey = this.favoritePreviewKey(favorite);

      if (multiSelect && this.isFavoriteSelected(favorite)) {
        this.removerSelecaoFavorito(favorite);
        return;
      }

      this.sourceSelectionTouched = true;
      this.sourceKey = favorite.sourceKey;
      this.deviceId = favorite.videoId;
      this.audioId = favorite.audioId || "";

      if (!multiSelect) {
        this.visiblePreviewKeys = [];
        this.pendingPreviewItems = [];
      }

      if (this.selecionarPreviewAtual()) {
        this.removerPreviewPendente(previewKey);
      } else {
        this.adicionarPreviewPendente(favorite);
      }

      if (
        previousSourceKey !== this.sourceKey ||
        !this.socket ||
        !this.socket.connected ||
        !this.socket.auth ||
        this.socket.auth.sourceKey !== this.sourceKey
      ) {
        this.connected = false;
        this.transmitPending = false;
        this.previewPending = false;
        this.conectarSocket();
      }
    },
    removerSelecaoFavorito(favorite) {
      const previewKey = this.favoritePreviewKey(favorite);
      const selectionKey = this.favoriteSourceSelectionKey(favorite);

      this.visiblePreviewKeys = this.visiblePreviewKeys.filter((key) => key !== previewKey);
      this.pendingPreviewItems = this.pendingPreviewItems.filter((pending) => {
        return this.sourceSelectionKey(pending.sourceKey, pending.deviceId, pending.audioId || "") != selectionKey;
      });
      this.previewOrder = this.previewOrder.filter((key) => key !== previewKey);

      if (this.favoriteSourceSelectionKey(favorite) == this.currentSourceSelectionKey()) {
        this.selecionarPrimeiraSelecaoAberta();
      }

      if (this.visiblePreviewKeys.length == 0 && this.pendingPreviewItems.length == 0) {
        this.previewPending = false;
        this.previewLoading = false;
      }

      this.schedulePreviewFrameHeightUpdate();
    },
    selecionarPrimeiraSelecaoAberta() {
      const pending = this.pendingPreviewItems[0];

      if (pending) {
        this.sourceKey = pending.sourceKey;
        this.deviceId = pending.deviceId;
        this.audioId = pending.audioId || "";
        return;
      }

      const preview = this.previewItems.find((item) => this.visiblePreviewKeys.includes(item.key));

      if (preview) {
        this.sourceKey = preview.sourceKey;
        this.deviceId = preview.deviceId;
        this.audioId = preview.audioId || "";
        return;
      }

      this.limparSourceSelecionado();
    },
    adicionarPreviewPendente(favorite) {
      const key = this.favoritePreviewKey(favorite);
      const exists = this.pendingPreviewItems.some((item) => item.key == key);

      if (exists) {
        this.registerPreviewOrder(key);
        return;
      }

      this.pendingPreviewItems.push({
        key,
        sourceKey: favorite.sourceKey,
        sourceNome: favorite.sourceNome || favorite.hostname || favorite.sourceKey,
        hostname: favorite.hostname || "",
        deviceId: favorite.videoId,
        videoLabel: favorite.videoLabel || favorite.videoId,
        audioId: favorite.audioId || "",
        audioLabel: favorite.audioLabel || favorite.audioId || "",
      });
      this.registerPreviewOrder(key);
      this.schedulePreviewFrameHeightUpdate();
    },
    removerPreviewPendente(key) {
      this.pendingPreviewItems = this.pendingPreviewItems.filter((item) => item.key !== key);
    },
    registerPreviewOrder(key) {
      if (!this.previewOrder.includes(key)) {
        this.previewOrder.push(key);
      }
    },
    previewTileOrder(key) {
      const index = this.previewOrder.indexOf(key);
      return index >= 0 ? index : this.previewOrder.length;
    },
    selecionarPreviewPendente(pending) {
      this.sourceSelectionTouched = true;
      this.sourceKey = pending.sourceKey;
      this.deviceId = pending.deviceId;
      this.audioId = pending.audioId || "";
    },
    solicitarPreviewPendente(pending) {
      this.selecionarPreviewPendente(pending);
      this.solicitarPreviewAtual();
    },
    transmitirPreviewPendente(pending) {
      this.selecionarPreviewPendente(pending);
      this.transmitirSourceAtual();
    },
    async removerFavoritoPendente(pending) {
      if (this.isActiveTransmissionSelection(pending.sourceKey, pending.deviceId, pending.audioId || "")) {
        this.mensagem = "Pare a transmissão antes de remover este source.";
        return;
      }
      this.selecionarPreviewPendente(pending);
      await this.removerFavoritoAtual();
    },
    isPendingSelected(pending) {
      return (
        pending.sourceKey == this.sourceKey &&
        pending.deviceId == this.deviceId &&
        (pending.audioId || "") == (this.audioId || "")
      );
    },
    isFavoriteSelected(favorite) {
      return (
        this.isFavoriteCurrentSelection(favorite) ||
        this.isFavoritePreviewSelected(favorite)
      );
    },
    isFavoriteCurrentSelection(favorite) {
      return (
        favorite.sourceKey == this.sourceKey &&
        favorite.videoId == this.deviceId &&
        (favorite.audioId || "") == (this.audioId || "")
      );
    },
    isFavoritePreviewSelected(favorite) {
      const key = this.favoritePreviewKey(favorite);
      return (
        this.isPreviewVisible(key) ||
        this.pendingPreviewItems.some((item) => item.key == key)
      );
    },
    isFavoritePreviewVisible(favorite) {
      return this.isPreviewVisible(this.favoritePreviewKey(favorite));
    },
    favoritePreviewKey(favorite) {
      const servidor = process.env.VUE_APP_SERVIDOR_PADRAO || this.defaultServerKey(this.item);
      return [
        favorite.sourceKey || "",
        favorite.videoId || "",
        favorite.audioId || "",
        servidor || "",
      ].join("::");
    },
    sourceSelectionKey(sourceKey, videoId, audioId) {
      return [
        sourceKey || "",
        videoId || "",
        audioId || "",
      ].join("::");
    },
    currentSourceSelectionKey() {
      return this.sourceSelectionKey(this.sourceKey, this.deviceId, this.audioId);
    },
    favoriteSourceSelectionKey(favorite) {
      return this.sourceSelectionKey(
        favorite.sourceKey,
        favorite.videoId,
        favorite.audioId || "",
      );
    },
    isFavoriteTransmitting(favorite) {
      return this.isActiveTransmissionSelection(
        favorite.sourceKey,
        favorite.videoId,
        favorite.audioId || "",
      );
    },
    previewSourceSelectionKey(preview) {
      return this.sourceSelectionKey(
        preview.sourceKey,
        preview.deviceId,
        preview.audioId || "",
      );
    },
    isPreviewTransmitting(preview) {
      return this.isActiveTransmissionSelection(
        preview.sourceKey,
        preview.deviceId,
        preview.audioId || "",
      );
    },
    normalizeAudioId(audioId) {
      const value = (audioId || "").toString();
      return value == "none" ? "" : value;
    },
    isActiveTransmissionSelection(sourceKey, videoId, audioId) {
      if (!this.activeTransmissionSource || !this.activeTransmissionSource.sourceKey) {
        return false;
      }

      if ((sourceKey || "") != this.activeTransmissionSource.sourceKey) {
        return false;
      }

      if (
        this.activeTransmissionSource.videoId &&
        videoId &&
        this.activeTransmissionSource.videoId != videoId
      ) {
        return false;
      }

      const activeAudioId = this.normalizeAudioId(this.activeTransmissionSource.audioId);
      const candidateAudioId = this.normalizeAudioId(audioId);

      return (
        activeAudioId == candidateAudioId ||
        activeAudioId == "" ||
        candidateAudioId == "" ||
        activeAudioId == "default" ||
        candidateAudioId == "default"
      );
    },
    aplicarEstadoTransmissaoRemota(payload) {
      const states = payload.transmissionStates || {};
      const state = states[this.item._id] || (payload.transmissionState && payload.transmissionState.event);

      if (!state || state.eventoId !== this.item._id) {
        return;
      }

      // Guard: only trust transmission state from a socket that has authority over it.
      // In adopt mode (initial page load), we trust all state to discover who is transmitting.
      // Once the user manually selects a source, we apply strict rules:
      //   - "active: false" → only accepted from the socket of the confirmed transmitting source
      //   - "active: true"  → only accepted from the confirmed source's socket, AND only when
      //                       the state claims that SAME source is transmitting (not cross-source
      //                       global state where e.g. wilson-pc1 reports daniel-desk as the
      //                       active transmitter, which may be stale from a previous session).
      const currentSocketSource = this.socket && this.socket.auth && this.socket.auth.sourceKey;
      const isAdoptMode = !this.sourceSelectionTouched || this.sourceKey === "" || this.deviceId === "";

      if (!isAdoptMode) {
        const confirmedSource = this.activeTransmissionSource && this.activeTransmissionSource.sourceKey;
        if (state.active === false) {
          if (!confirmedSource || currentSocketSource !== confirmedSource) {
            return;
          }
        } else {
          if (!confirmedSource || currentSocketSource !== confirmedSource || state.sourceKey !== currentSocketSource) {
            return;
          }
        }
      }

      Object.keys(this.canais).forEach((key) => {
        this.canais[key].status = false;
      });

      if (state.active === false) {
        this.activeTransmissionSourceKey = "";
        this.activeTransmissionSource = null;
        this.pendingTransmissionSourceKey = "";
        this.$forceUpdate();
        return;
      }

      (state.channels || []).forEach((channel) => {
        const key = String(channel.canal);
        if (this.canais[key]) {
          this.canais[key].status = true;
          this.ensureChannelVisible(key);
          if (channel.servidor) {
            this.canais[key].servidor = channel.servidor;
          }
        }
      });

      const transmissionSourceKey = this.sourceSelectionKey(
        state.sourceKey || "",
        state.deviceId || "",
        state.audioId || "",
      );
      this.activeTransmissionSourceKey = transmissionSourceKey;
      this.activeTransmissionSource = {
        sourceKey: state.sourceKey || "",
        videoId: state.deviceId || "",
        audioId: state.audioId || "",
      };
      this.pendingTransmissionSourceKey = "";

      const shouldAdoptTransmissionSource =
        !this.sourceSelectionTouched ||
        this.sourceKey === "" ||
        this.deviceId === "";

      if (shouldAdoptTransmissionSource) {
        this.sourceKey = state.sourceKey || this.sourceKey;
        this.deviceId = state.deviceId || this.deviceId;
        this.audioId = state.audioId || "";
      }

      if (
        shouldAdoptTransmissionSource &&
        this.sourceKey &&
        (!this.socket || !this.socket.connected || !this.socket.auth || this.socket.auth.sourceKey !== this.sourceKey)
      ) {
        this.conectarSocket();
      }

      this.$forceUpdate();
    },
    async salvarFavorito(favorito, dados) {
      const source = dados || this.selectedSource;
      const video = dados ? null : this.selectedVideo;
      const audio = dados ? null : this.selectedAudio;

      const response = await api.put(
        "/evento/" + this.item._id + "/remote-source",
        {
          favorito,
          sourceKey: dados ? dados.sourceKey : this.sourceKey,
          sourceNome:
            source.nome || source.sourceNome || source.hostname || source.sourceKey || this.sourceKey,
          hostname: source.hostname || "",
          videoId: dados ? dados.deviceId : this.deviceId,
          videoLabel: dados
            ? dados.videoLabel || dados.deviceId
            : video ? video.label || video.id : this.deviceId,
          audioId: dados ? dados.audioId || "" : this.audioId,
          audioLabel: dados
            ? dados.audioLabel || dados.audioId || ""
            : audio ? audio.label || audio.id : this.audioId,
        },
      );
      api.valid(response.data, this.$router);

      if (!response.data.erro) {
        this.item.remoteSources = response.data.remoteSources || [];
        return true;
      } else {
        this.mensagem = response.data.mensagem || "Erro ao salvar favorito.";
      }

      return false;
    },
    buildChannelPayload(keys) {
      return keys.map((key) => ({
        canal: parseInt(key),
        servidor: this.canais[key].servidor,
      }));
    },
    transmitirCanaisHabilitados() {
      const selectedKeys = this.selectedChannelKeys("status");
      const candidateKeys = selectedKeys.length > 0 ? selectedKeys : Object.keys(this.canais);
      const keys = candidateKeys.filter((key) => {
        return this.isChannelEnabled(key) && !this.canais[key].status;
      });

      this.iniciarTransmissao(keys);
    },
    pararCanaisAtivos() {
      const selectedKeys = this.selectedChannelKeys("status");
      const candidateKeys = selectedKeys.length > 0 ? selectedKeys : Object.keys(this.canais);
      const keys = candidateKeys.filter((key) => this.canais[key].status);

      this.pararTransmissao(keys);
    },
    cliqueCanal(keyCanal, event) {
      if (event.ctrlKey || event.metaKey || event.shiftKey) {
        this.selecionarCanal(keyCanal, event, "status");
        return;
      }

      const selectedKeys = this.selectedChannelKeys("status");
      const keys = selectedKeys.includes(keyCanal) ? selectedKeys : [keyCanal];
      const enabledKeys = keys.filter((key) => this.isChannelEnabled(key));
      const shouldStop = this.canais[keyCanal].status;
      const actionKeys = enabledKeys.filter((key) => {
        return shouldStop ? this.canais[key].status : !this.canais[key].status;
      });

      if (shouldStop) {
        this.pararTransmissao(actionKeys);
      } else {
        this.iniciarTransmissao(actionKeys);
      }

      this.selecionarCanalLimpar();
    },
    iniciarTransmissao(keys, options) {
      if (!this.validarTransmissao() || keys.length == 0) {
        return;
      }

      const forceCanalZero = options && options.forceCanalZero === true;
      const sortedKeys = keys.map((key) => key.toString()).sort((a, b) => parseInt(a) - parseInt(b));
      const hasCanalZero = sortedKeys.includes("0");
      const hasActiveCanalZero = this.canais["0"] && this.canais["0"].status;

      if (!forceCanalZero && !hasActiveCanalZero && (sortedKeys.length != 1 || !hasCanalZero)) {
        this.mensagem = "Inicie a transmissao pelo canal 0 antes de replicar.";
        return;
      }

      if (!forceCanalZero && hasActiveCanalZero && hasCanalZero) {
        this.mensagem = "Canal 0 ja esta transmitindo.";
        return;
      }

      this.loading = true;
      this.mensagem = "Solicitando transmissao remota...";
      this.pendingTransmissionSourceKey = hasCanalZero ? this.currentSourceSelectionKey() : "";
      this.socket.emit("source:transmit:start", {
        commandId: Date.now().toString(),
        eventoId: this.item._id,
        eventoNome: this.item.nome || "",
        sourceKey: this.sourceKey,
        channels: this.buildChannelPayload(sortedKeys),
        deviceId: this.deviceId,
        deviceLabel: this.selectedVideo ? this.selectedVideo.label : this.deviceId,
        audioId: this.audioId,
        audioLabel: this.selectedAudio ? this.selectedAudio.label : this.audioId,
      });
    },
    transmitirPreview(preview) {
      if (!preview || !preview.sourceKey || !preview.deviceId) {
        return;
      }

      const sameConnectedSource =
        this.socket &&
        this.socket.connected &&
        this.socket.auth &&
        this.socket.auth.sourceKey == preview.sourceKey &&
        this.connected;
      const keysToTransmit = this.channelKeysForSourceSwitch();

      this.sourceSelectionTouched = true;
      this.sourceKey = preview.sourceKey;
      this.deviceId = preview.deviceId;
      this.audioId = preview.audioId || "";
      this.connected = sameConnectedSource;
      this.previewPending = false;
      this.pendingTransmissionSourceKey = this.previewSourceSelectionKey(preview);
      this.showPreviewKey(preview.key);

      if (sameConnectedSource) {
        this.iniciarTransmissao(keysToTransmit, { forceCanalZero: true });
        return;
      }

      this.transmitPending = true;
      this.mensagem = "Conectando ao source para transmitir.";
      this.conectarSocket();
    },
    transmitirSourceAtual() {
      if (!this.sourceKey || !this.deviceId) {
        this.mensagem = "Selecione source e video.";
        return;
      }

      const keysToTransmit = this.channelKeysForSourceSwitch();
      if (this.socket && this.socket.connected && this.connected) {
        this.pendingTransmissionSourceKey = this.currentSourceSelectionKey();
        this.iniciarTransmissao(keysToTransmit, { forceCanalZero: true });
        return;
      }

      this.transmitPending = true;
      this.previewPending = false;
      this.pendingTransmissionSourceKey = this.currentSourceSelectionKey();
      this.mensagem = "Conectando ao source para transmitir.";
      this.conectarSocket();
    },
    channelKeysForSourceSwitch() {
      const activeKeys = Object.keys(this.canais).filter((key) => this.canais[key].status);

      if (!activeKeys.includes("0")) {
        activeKeys.push("0");
      }

      return activeKeys.sort((a, b) => parseInt(a) - parseInt(b));
    },
    pararTransmissao(keys) {
      if (!this.socket || !this.connected || keys.length == 0) {
        return;
      }

      const sortedKeys = keys.map((key) => key.toString()).sort((a, b) => parseInt(a) - parseInt(b));
      this.loading = true;
      this.mensagem = "Parando transmissao remota...";
      this.socket.emit("source:transmit:stop", {
        commandId: Date.now().toString(),
        eventoId: this.item._id,
        channels: this.buildChannelPayload(sortedKeys),
      });
    },
    validarTransmissao() {
      if (!this.socket || !this.connected) {
        this.mensagem = "Source offline ou nao conectado.";
        return false;
      }

      if (!this.sourceKey || !this.deviceId) {
        this.mensagem = "Selecione source e video.";
        return false;
      }

      return true;
    },
    iniciarPreview(forceReload) {
      if (!this.socket || !this.connected || this.deviceId == "") {
        return;
      }

      if (this.selecionarPreviewAtual()) {
        if (forceReload === true) {
          this.recarregarPreviewAtual();
          this.mensagem = "Preview atualizado.";
          return;
        }

        this.previewPending = false;
        this.previewLoading = false;
        this.mensagem = "Preview reutilizado.";
        return;
      }

      const commandId = "preview_" + Date.now().toString();
      this.activePreviewCommandId = commandId;
      this.previewLoading = true;
      this.mensagem = "Carregando preview...";
      this.socket.emit("source:preview:start", {
        commandId,
        sourceKey: this.sourceKey,
        deviceId: this.deviceId,
        deviceLabel: this.selectedVideo ? this.selectedVideo.label : this.deviceId,
        audioId: this.audioId,
        audioLabel: this.selectedAudio ? this.selectedAudio.label : this.audioId,
        servidor: process.env.VUE_APP_SERVIDOR_PADRAO || this.defaultServerKey(this.item),
      });
    },
    solicitarPreviewAtual() {
      if (!this.sourceKey || !this.deviceId) {
        this.mensagem = "Selecione source e video.";
        return;
      }

      if (this.selecionarPreviewAtual()) {
        return;
      }

      if (this.socket && this.connected) {
        this.iniciarPreview();
        return;
      }

      this.previewPending = true;
      this.mensagem = "Conectando ao source para carregar preview.";
      this.conectarSocket();
    },
    async onPreviewStatus(payload) {
      if (
        payload.commandId &&
        this.activePreviewCommandId &&
        payload.commandId !== this.activePreviewCommandId
      ) {
        return;
      }

      if (payload.status == "error") {
        this.previewLoading = false;
        this.mensagem = payload.error || "Erro ao carregar preview.";
        return;
      }

      if (payload.status == "received") {
        this.mensagem = "Preview solicitado.";
      } else if (payload.status == "creating-event") {
        this.mensagem = "Preparando preview.";
      } else if (payload.status == "starting-transmission") {
        this.mensagem = "Iniciando preview.";
      } else if (payload.status == "started") {
        this.previewLoading = false;
        this.mensagem = payload.reused ? "Preview reutilizado." : "Preview iniciado.";
        this.carregarPreview(payload.eventoId, payload.commandId);
      }
    },
    resetPreviewPlayer() {
      this.visiblePreviewKeys = [];
    },
    carregarPreview(eventoId, commandId) {
      if (
        commandId &&
        this.activePreviewCommandId &&
        commandId !== this.activePreviewCommandId
      ) {
        return;
      }

      const key = this.currentPreviewKey();
      const exists = this.previewItems.some((item) => item.key == key);
      this.registerPreviewOrder(key);

      if (!exists) {
        this.previewItems.push({
          key,
          eventoId,
          sourceKey: this.sourceKey,
          sourceNome: this.selectedSource.nome || this.selectedSource.hostname || this.sourceKey,
          hostname: this.selectedSource.hostname || "",
          deviceId: this.deviceId,
          videoLabel: this.selectedVideo ? this.selectedVideo.label || this.deviceId : this.deviceId,
          audioId: this.audioId || "",
          audioLabel: this.selectedAudio ? this.selectedAudio.label || this.audioId : this.audioId,
          reloadToken: 0,
        });
      }

      this.showPreviewKey(key);
      this.removerPreviewPendente(key);
      this.schedulePreviewFrameHeightUpdate();
    },
    currentPreviewKey() {
      const servidor = process.env.VUE_APP_SERVIDOR_PADRAO || this.defaultServerKey(this.item);
      return [
        this.sourceKey || "",
        this.deviceId || "",
        this.audioId || "",
        servidor || "",
      ].join("::");
    },
    selecionarPreviewAtual() {
      const key = this.currentPreviewKey();
      const exists = this.previewItems.some((item) => item.key == key);

      if (exists) {
        this.showPreviewKey(key);
        this.schedulePreviewFrameHeightUpdate();
        return true;
      }

      return false;
    },
    recarregarPreviewAtual() {
      const key = this.currentPreviewKey();
      const preview = this.previewItems.find((item) => item.key == key);

      return this.recarregarPreview(preview);
    },
    recarregarPreview(preview) {
      if (!preview) {
        return false;
      }

      this.showPreviewKey(preview.key);
      this.$set(preview, "reloadToken", Date.now());
      this.schedulePreviewFrameHeightUpdate();
      this.mensagem = "Preview atualizado.";
      return true;
    },
    async removerFavoritoPreview(preview) {
      if (this.isPreviewTransmitting(preview)) {
        this.mensagem = "Pare a transmissão antes de remover este source.";
        return;
      }
      const removed = await this.salvarFavorito(false, preview);

      if (!removed) {
        return;
      }

      this.fecharPreviewDaSelecao(preview.sourceKey, preview.deviceId, preview.audioId || "");

      if (
        preview.sourceKey == this.sourceKey &&
        preview.deviceId == this.deviceId &&
        (preview.audioId || "") == (this.audioId || "")
      ) {
        this.limparSourceSelecionado();
      }
    },
    async removerFavoritoAtual() {
      if (this.isActiveTransmissionSelection(this.sourceKey, this.deviceId, this.audioId || "")) {
        this.mensagem = "Pare a transmissão antes de remover este source.";
        return;
      }
      const sourceKey = this.sourceKey;
      const deviceId = this.deviceId;
      const audioId = this.audioId || "";
      const removed = await this.salvarFavorito(false);

      if (!removed) {
        return;
      }

      this.fecharPreviewDaSelecao(sourceKey, deviceId, audioId);
      this.limparSourceSelecionado();
    },
    fecharPreviewDaSelecao(sourceKey, deviceId, audioId) {
      const selectionKey = this.sourceSelectionKey(sourceKey, deviceId, audioId || "");
      const previewKeys = this.previewItems
        .filter((preview) => this.previewSourceSelectionKey(preview) == selectionKey)
        .map((preview) => preview.key);

      if (previewKeys.length == 0) {
        return;
      }

      this.previewItems = this.previewItems.filter((preview) => !previewKeys.includes(preview.key));
      this.visiblePreviewKeys = this.visiblePreviewKeys.filter((key) => !previewKeys.includes(key));
      this.previewOrder = this.previewOrder.filter((key) => !previewKeys.includes(key));
      this.pendingPreviewItems = this.pendingPreviewItems.filter((pending) => {
        return this.sourceSelectionKey(pending.sourceKey, pending.deviceId, pending.audioId || "") != selectionKey;
      });

      if (this.visiblePreviewKeys.length == 0) {
        this.previewPending = false;
        this.previewLoading = false;
      }

      this.schedulePreviewFrameHeightUpdate();
    },
    limparSourceSelecionado() {
      this.sourceKey = "";
      this.deviceId = "";
      this.audioId = "";
      this.connected = false;
      this.previewPending = false;
      this.previewLoading = false;
      this.pendingPreviewItems = [];
      this.previewOrder = [];
      this.fecharSocket();
    },
    isCurrentFavorite() {
      return this.remoteSources.some((item) => {
        return (
          item.sourceKey == this.sourceKey &&
          item.videoId == this.deviceId &&
          (item.audioId || "") == (this.audioId || "")
        );
      });
    },
    isPreviewFavorite(preview) {
      return this.remoteSources.some((item) => {
        return (
          item.sourceKey == preview.sourceKey &&
          item.videoId == preview.deviceId &&
          (item.audioId || "") == (preview.audioId || "")
        );
      });
    },
    isPendingFavorite(pending) {
      return this.isPreviewFavorite(pending);
    },
    showPreviewKey(key) {
      if (!this.visiblePreviewKeys.includes(key)) {
        this.visiblePreviewKeys.push(key);
      }
      this.schedulePreviewFrameHeightUpdate();
    },
    isPreviewVisible(key) {
      return this.visiblePreviewKeys.includes(key);
    },
    isCurrentPreviewVisible() {
      return this.isPreviewVisible(this.currentPreviewKey());
    },
    atualizarPreviewFrameHeight() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }

      this.resizeTimer = setTimeout(() => {
        window.requestAnimationFrame(() => {
          const container = this.$refs.remotePreviewPlayer;
          const visibleTiles = container
            ? container.querySelectorAll(".remotePreviewTile:not(.remotePreviewHidden)")
            : [];
          const firstTile = visibleTiles.length ? visibleTiles[0] : null;
          const width = firstTile ? firstTile.clientWidth : container ? container.clientWidth : 0;

          if (!width) {
            return;
          }

          const ratioHeight = Math.round((width * 9) / 16);
          const maxHeight = Math.max(260, Math.round(window.innerHeight * 0.7));
          this.previewFrameHeight = Math.max(260, Math.min(ratioHeight, maxHeight));
        });
      }, 50);
    },
    schedulePreviewFrameHeightUpdate() {
      this.$nextTick(() => {
        this.atualizarPreviewFrameHeight();
        setTimeout(this.atualizarPreviewFrameHeight, 120);
        setTimeout(this.atualizarPreviewFrameHeight, 300);
      });
    },
    onTransmitStatus(payload) {
      if (payload.transmissionState) {
        this.aplicarEstadoTransmissaoRemota({
          transmissionState: payload.transmissionState,
        });
      }

      if (payload.status == "error") {
        this.loading = false;
        this.pendingTransmissionSourceKey = "";
        this.mensagem = payload.error || "Erro na transmissao remota.";
        return;
      }

      if (payload.status == "received") {
        this.mensagem = "Comando recebido pelo source.";
      } else if (payload.status == "preparing-channels") {
        this.mensagem = "Preparando canais.";
      } else if (payload.status == "starting-transmission") {
        this.mensagem = "Iniciando transmissao.";
      } else if (payload.status == "switching-source") {
        this.mensagem = "Trocando source da transmissao.";
      } else if (payload.status == "channel-started") {
        this.mensagem = "Canal " + payload.canal + " preparado.";
      } else if (payload.status == "started") {
        this.loading = false;
        this.mensagem = payload.reused ? "Transmissao reutilizada." : "Transmissao iniciada.";
        (payload.canais || []).forEach((canal) => {
          if (this.canais[canal]) {
            this.canais[canal].status = true;
            this.ensureChannelVisible(canal);
          }
        });
        if ((payload.canais || []).includes(0) || (payload.canais || []).includes("0")) {
          this.activeTransmissionSourceKey = this.pendingTransmissionSourceKey || this.currentSourceSelectionKey();
          this.activeTransmissionSource = {
            sourceKey: this.sourceKey || "",
            videoId: this.deviceId || "",
            audioId: this.audioId || "",
          };
          this.pendingTransmissionSourceKey = "";
        }
        this.selecionarCanalLimpar();
        this.$forceUpdate();
      } else if (payload.status == "stopped") {
        this.loading = false;
        this.mensagem = "Transmissao parada.";
        const canais = payload.canais || Object.keys(this.canais);
        const stoppedZero = canais.includes(0) || canais.includes("0");
        canais.forEach((canal) => {
          if (this.canais[canal]) {
            this.canais[canal].status = false;
          }
        });
        if (stoppedZero) {
          Object.keys(this.canais).forEach((key) => {
            this.canais[key].status = false;
          });
          this.activeTransmissionSourceKey = "";
          this.activeTransmissionSource = null;
          this.pendingTransmissionSourceKey = "";
        }
        this.selecionarCanalLimpar();
        this.$forceUpdate();
      }
    },
    async aoVivo() {
      if (confirm("Publicar como ao vivo ?")) {
        const response = await api.put("/evento/aovivo", { ids: [this.item._id] });
        api.valid(response.data, this.$router);

        if (response.data.erro == false) {
          this.item.situacao = 3;
        }
      }
    },
    async encerrar() {
      if (confirm("Encerrar evento ?")) {
        const response = await api.put("/evento/encerrar", { ids: [this.item._id] });
        api.valid(response.data, this.$router);

        if (response.data.erro == false) {
          this.item.situacao = 4;
        }
      }
    },
    situacaoLabel(situacao) {
      const status = this.statusOptions.find((item) => item.value == parseInt(situacao));
      return status ? status.label : "Status";
    },
    statusButtonClass(situacao) {
      const value = parseInt(situacao);

      if (value == 1) {
        return "btn-outline-primary";
      }

      if (value == 2) {
        return "btn-outline-secondary";
      }

      if (value == 3) {
        return "btn-outline-success";
      }

      if (value == 4) {
        return "btn-outline-danger";
      }

      return "btn-outline-secondary";
    },
    async alterarSituacaoEvento(situacao) {
      const value = parseInt(situacao);

      if (value == parseInt(this.item.situacao)) {
        this.statusMenuOpen = false;
        return;
      }

      if (value == 3 && !confirm("Publicar como ao vivo ?")) {
        this.statusMenuOpen = false;
        return;
      }

      if (value == 4 && !confirm("Encerrar evento ?")) {
        this.statusMenuOpen = false;
        return;
      }

      const response = await api.put("/evento/" + this.item._id, { situacao: value });
      api.valid(response.data, this.$router);

      if (response.data.erro == false) {
        this.item.situacao = value;
      }

      this.statusMenuOpen = false;
    },
    async definirCanais(keyCanal) {
      if (parseInt(keyCanal) < 1) {
        return;
      }

      if (confirm("Definir para " + keyCanal + " canais ?")) {
        const response = await api.put("/evento/canais", {
          evento: this.item._id,
          canais: parseInt(keyCanal),
        });
        api.valid(response.data, this.$router);

        if (response.data.erro == false) {
          this.item.canais = parseInt(keyCanal);
        }
      }
    },
    async adicionarCanalRemoto() {
      const nextChannel = this.channelDisplayMax + 1;
      this.ensureChannelExists(nextChannel);
      this.channelDisplayCount = nextChannel;
    },
    editarCanal(canal) {
      this.canalEdicao = canal;
      window.$("#modalCanalRemoto").modal("show");
    },
    alterarCanalServidor(servidor) {
      const selectedKeys = this.selectedChannelKeys("servidor");

      if (selectedKeys.includes(this.canalEdicao)) {
        selectedKeys.forEach((key) => {
          this.canais[key].servidor = servidor;
        });
        this.selecionarCanalLimpar();
      } else if (this.canalEdicao !== "") {
        this.canais[this.canalEdicao].servidor = servidor;
      }
      this.$forceUpdate();
    },
    servidorNome(servidor) {
      const item = this.$global.servidores_sip()[servidor];
      return item ? item.nome : servidor;
    },
    isChannelEnabled(keyCanal) {
      if (this.canais[keyCanal] && this.canais[keyCanal].status) {
        return true;
      }

      if (keyCanal == "0") {
        return this.connected && this.deviceId !== "";
      }

      return this.canais["0"] && this.canais["0"].status;
    },
    selecionarCanalLimpar() {
      this.selecaoCanais.tipo = "";
      this.selecaoCanais.primeiro = null;
      this.selecaoCanais.itens = {};
    },
    selecionarCanal(keyCanal, event, tipo) {
      event.preventDefault();

      if (!this.canSelectChannel(keyCanal, tipo)) {
        return;
      }

      if (this.selecaoCanais.tipo !== tipo) {
        this.selecaoCanais.tipo = tipo;
        this.selecaoCanais.primeiro = parseInt(keyCanal);
        this.selecaoCanais.itens = {};
      }

      if (event.ctrlKey || event.metaKey) {
        if (this.selecaoCanais.itens[keyCanal]) {
          delete this.selecaoCanais.itens[keyCanal];
        } else {
          this.selecaoCanais.itens[keyCanal] = true;
          this.selecaoCanais.primeiro = parseInt(keyCanal);
        }
      } else if (event.shiftKey) {
        let arrKeys = Object.keys(this.selecaoCanais.itens);

        if (arrKeys.length == 0) {
          this.selecaoCanais.itens[keyCanal] = true;
        } else {
          let arrSelecaoCanaisTemp = {};
          let indiceInicio = parseInt(this.selecaoCanais.primeiro);
          let indiceFim = parseInt(keyCanal);
          let passo = indiceInicio <= indiceFim ? 1 : -1;

          for (
            let indiceKey = indiceInicio;
            passo > 0 ? indiceKey <= indiceFim : indiceKey >= indiceFim;
            indiceKey += passo
          ) {
            const key = indiceKey.toString();
            if (this.canSelectChannel(key, tipo)) {
              arrSelecaoCanaisTemp[key] = true;
            }
          }

          this.selecaoCanais.itens = arrSelecaoCanaisTemp;
        }
      }

      this.$forceUpdate();
    },
    selectedChannelKeys(tipo) {
      if (this.selecaoCanais.tipo !== tipo) {
        return [];
      }

      return Object.keys(this.selecaoCanais.itens).filter((key) => {
        return this.selecaoCanais.itens[key] && this.canais[key];
      });
    },
    isChannelSelected(keyCanal, tipo) {
      return (
        this.selecaoCanais.tipo == tipo &&
        this.selecaoCanais.itens[keyCanal] == true
      );
    },
    isChannelConfigurable(keyCanal) {
      if (this.canais["0"] && this.canais["0"].status) {
        return true;
      }

      return keyCanal == "0" || parseInt(keyCanal) <= this.channelDisplayMax;
    },
    isEventChannel(keyCanal) {
      return parseInt(keyCanal) <= parseInt(this.item.canais || 1);
    },
    canSelectChannel(keyCanal, tipo) {
      if (tipo == "servidor") {
        return this.isChannelConfigurable(keyCanal);
      }

      return this.isChannelEnabled(keyCanal);
    },
    cliquePlayerCanal(keyCanal, event) {
      if (event && (event.ctrlKey || event.metaKey || event.shiftKey)) {
        this.definirCanais(keyCanal);
        return;
      }

      this.abrirEvento(keyCanal);
    },
    abrirEvento(canal) {
      window.open(
        "/view/" + this.item._id + "?view=clean&canal=" + canal,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true,
      );
    },
    abrirTransmissaoLocal() {
      window.open(
        "/transmit/" + this.item._id,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=700,height=750",
        true,
      );
    },
  },
  mounted() {
    this.carregarItem(this.$route.params.id);
    this.carregarSources();
    window.addEventListener("resize", this.atualizarPreviewFrameHeight);
    this.$nextTick(this.atualizarPreviewFrameHeight);
  },
  beforeDestroy() {
    this.fecharSocket();
    window.removeEventListener("resize", this.atualizarPreviewFrameHeight);

    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }
  },
  computed: {
    selectedSource: function () {
      return this.sources.find((item) => item.key == this.sourceKey) || {};
    },
    dialogSelectedSource: function () {
      return this.sources.find((item) => item.key == this.dialogSourceKey) || {};
    },
    videoDevices: function () {
      const devices = this.selectedSource.devices && this.selectedSource.devices.videos
        ? this.selectedSource.devices.videos
        : [];
      return devices.slice().sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    dialogVideoDevices: function () {
      const devices = this.dialogSelectedSource.devices && this.dialogSelectedSource.devices.videos
        ? this.dialogSelectedSource.devices.videos
        : [];
      return devices.slice().sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    audioDevices: function () {
      const audios = this.selectedSource.devices && this.selectedSource.devices.audios
        ? this.selectedSource.devices.audios
        : [];
      return audios.filter((item) => item.id !== "none")
        .sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    dialogAudioDevices: function () {
      const audios = this.dialogSelectedSource.devices && this.dialogSelectedSource.devices.audios
        ? this.dialogSelectedSource.devices.audios
        : [];
      return audios.filter((item) => item.id !== "none")
        .sort((a, b) => (a.label || a.id).localeCompare(b.label || b.id));
    },
    selectedVideo: function () {
      return this.videoDevices.find((item) => item.id == this.deviceId);
    },
    selectedAudio: function () {
      return this.audioDevices.find((item) => item.id == this.audioId);
    },
    remoteSources: function () {
      return this.item.remoteSources || [];
    },
    statusMenuOptions: function () {
      return this.statusOptions.filter((status) => status.value != parseInt(this.item.situacao));
    },
    previewTiles: function () {
      const byKey = {};

      this.pendingPreviewItems.forEach((item) => {
        byKey[item.key] = {
          ...item,
          type: "pending",
        };
      });

      this.previewItems.forEach((item) => {
        byKey[item.key] = {
          ...item,
          type: "preview",
        };
      });

      const ordered = [];
      this.previewOrder.forEach((key) => {
        if (byKey[key]) {
          ordered.push(byKey[key]);
          delete byKey[key];
        }
      });

      return ordered.concat(Object.keys(byKey).map((key) => byKey[key]));
    },
    channelDisplayMax: function () {
      return Math.max(3, parseInt(this.channelDisplayCount || this.item.canais || 1));
    },
    channelKeys: function () {
      return Object.keys(this.canais)
        .filter((key) => parseInt(key) <= this.channelDisplayMax)
        .sort((a, b) => parseInt(a) - parseInt(b));
    },
    canAddChannel: function () {
      return true;
    },
    canSaveFavorite: function () {
      return this.sourceKey !== "" && this.deviceId !== "";
    },
    servidoresTipo: function () {
      const objServidores = {};

      this.$global.servidores_sip_array().forEach((item) => {
        if (item.id.startsWith("ms_") && item.router == false) {
          objServidores[item.id] = item;
        }
      });

      return objServidores;
    },
    sourcesOrdered: function () {
      return this.sources
        .slice()
        .filter((item) => item.status == "online")
        .sort((a, b) =>
          (a.nome || a.hostname || a.key || "").localeCompare(
            b.nome || b.hostname || b.key || "",
            "pt-BR",
            { sensitivity: "base" }
          )
        );
    },
  },
  data: function () {
    return {
      item: {
        _id: "",
        nome: "",
        servidor: "",
        servidorTipo: "ms",
        situacao: "",
        canais: 1,
        remoteSources: [],
        dataDia: "",
        dataMes: "",
        dataAno: "",
        dataHora: "",
        dataMinuto: "",
      },
      sources: [],
      sourceKey: "",
      deviceId: "",
      audioId: "",
      dialogSourceKey: "",
      dialogDeviceId: "",
      dialogAudioId: "",
      socket: null,
      connected: false,
      canais: {},
      canalEdicao: "",
      selecaoCanais: {
        tipo: "",
        primeiro: null,
        itens: {},
      },
      loading: false,
      previewLoading: false,
      previewPending: false,
      transmitPending: false,
      sourceSelectionTouched: false,
      previewItems: [],
      visiblePreviewKeys: [],
      pendingPreviewItems: [],
      previewOrder: [],
      activePreviewCommandId: "",
      activeTransmissionSourceKey: "",
      activeTransmissionSource: null,
      pendingTransmissionSourceKey: "",
      previewFrameHeight: 360,
      channelDisplayCount: 3,
      resizeTimer: null,
      statusMenuOpen: false,
      statusOptions: [
        { value: 1, label: "Previsto" },
        { value: 2, label: "Invisivel" },
        { value: 3, label: "Ao vivo" },
        { value: 4, label: "Finalizado" },
      ],
      mensagem: "",
    };
  },
};
</script>

<style>
#app {
  margin-top: 10px;
}

.transmitRemoteEvento {
  padding: 10px;
}

.remoteEventHeader {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  text-align: center;
}

.remoteEventTitle {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.remoteEventTitle h5 {
  margin-bottom: 2px;
  padding-top: 2px;
}

.remoteStatusDropdown {
  position: relative;
  z-index: 5;
}

.remoteHeaderActions {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.remoteStatusButton {
  min-width: 96px;
}

.remoteStatusMenu {
  background: #ffffff;
  border: 1px solid #d9e1ec;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgba(20, 30, 45, 0.12);
  margin-top: 4px;
  min-width: 132px;
  overflow: hidden;
  position: absolute;
  right: 0;
  text-align: left;
}

.remoteStatusOption {
  background: #ffffff;
  border: 0;
  color: #354052;
  display: block;
  font-size: 13px;
  padding: 7px 10px;
  text-align: left;
  width: 100%;
}

.remoteStatusOption:hover:not(:disabled) {
  background: #f4f9ff;
}

.remoteStatusOption:disabled {
  color: #8a96a3;
  cursor: default;
}

.remoteStatusOptionActive {
  background: #eef5ff;
  color: #2f80ed;
  font-weight: 600;
}

.remoteHeaderMessage {
  color: #526173;
  display: block;
  margin-top: 3px;
}

.remoteSourceLayout {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  grid-gap: 14px;
  margin-top: 14px;
  margin-bottom: 14px;
}

.remoteFavoritesPanel {
  border-right: 1px solid #e4e8ee;
  padding: 12px 14px 12px 0;
}

.remotePreviewPanel {
  border: 0;
  padding: 0;
}

.remoteFavoritesPanel h6 {
  margin-bottom: 0px;
}

.remoteFavoriteEmpty {
  border: 1px dashed #d9e1ec;
  border-radius: 4px;
  margin-top: 10px;
  padding: 14px;
}

.remoteFavoriteCard {
  background: #ffffff;
  border: 1px solid #d9e1ec;
  border-left: 4px solid #b8c2cc;
  border-radius: 4px;
  color: #354052;
  display: block;
  margin-top: 8px;
  min-height: 68px;
  overflow: hidden;
  padding: 8px 10px;
  text-align: left;
  width: 100%;
}

.remoteFavoriteCard strong,
.remoteFavoriteCard span,
.remoteFavoriteCard small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remoteFavoriteCard span {
  font-size: 12px;
  margin-top: 3px;
}

.remoteFavoriteCard small {
  color: #6c757d;
}

.remoteFavoriteActive {
  background: #f4f9ff;
  border-color: #8bb8ee;
  border-left-color: #2f80ed;
}

.remoteFavoriteVisible {
  box-shadow: 0 0 0 2px rgba(47, 128, 237, 0.14);
}

.remoteFavoriteTransmitting {
  background: #f1fbf4;
  border-color: #8bd19a;
  border-left-color: #28a745;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.12);
}

.remoteTransmitIcon {
  color: #28a745;
  margin-right: 4px;
  vertical-align: -1px;
}

.remotePreviewPanel {
  min-height: 310px;
}

.remotePreviewEmpty {
  align-items: center;
  color: #6c757d;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 260px;
}

.remotePreviewPlayer {
  background: #111111;
  display: grid;
  gap: 0;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 360px), 1fr));
}

.remotePreviewTile {
  background: #111111;
  border-left: 1px solid #dfe6ef;
  min-width: 0;
}

.remotePreviewPendingTile {
  background: #111111;
  border-left: 1px solid #dfe6ef;
  min-width: 0;
}

.remotePreviewTile:first-child,
.remotePreviewPendingTile:first-child {
  border-left: 0;
}

.remotePreviewPendingTileFull {
  grid-column: 1 / -1;
}

.remotePreviewTileHeader {
  align-items: center;
  background: #f7f9fc;
  border: 1px solid #dfe6ef;
  border-bottom: 0;
  color: #263445;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding: 7px 9px;
}

.remoteSelectedSourceHeader {
  border-bottom: 1px solid #dfe6ef;
}

.remotePreviewTitle {
  min-width: 0;
}

.remotePreviewTitle strong,
.remotePreviewTitle small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remotePreviewTitle small {
  color: #6c757d;
  font-size: 12px;
}

.remotePreviewTileActions {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
}

.remoteIconButton {
  align-items: center;
  display: inline-flex;
  height: 26px;
  justify-content: center;
  padding: 0;
  width: 26px;
}

.remoteTransmitPreviewButton {
  height: 26px;
  line-height: 1;
  padding: 0 8px;
}

.remotePreviewPlayer iframe {
  background: #111111;
  border: 0;
  display: block;
  min-height: 260px;
  width: 100%;
}

.remotePreviewHidden {
  display: none !important;
  height: 0 !important;
  min-height: 0 !important;
  overflow: hidden;
  visibility: hidden;
}

.remotePreviewWaiting {
  align-items: center;
  color: #aeb7c2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  min-height: 260px;
  text-align: center;
  width: 100%;
}

.remotePreviewStartButton {
  min-width: 120px;
}

.remoteChannelToolbar {
  margin-bottom: 12px;
  min-width: 0;
  position: relative;
}

.remoteChannelBar {
  align-items: stretch;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-start;
  min-width: 0;
}

.remoteChannel {
  background: #f7f9fc;
  border: 1px solid #d8e0ea;
  border-radius: 6px;
  display: grid;
  flex: 0 0 56px;
  grid-template-rows: 30px 20px;
  min-height: 52px;
  min-width: 56px;
  overflow: hidden;
  text-align: center;
}

.remoteChannelButton,
.remoteServerButton {
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  display: flex;
  justify-content: center;
  margin: 0;
  width: 100%;
}

.remoteChannelButton {
  color: #27364a;
  font-size: 13px;
  font-weight: 700;
  padding: 0 4px;
}

.remoteServerButton {
  background: rgba(0, 0, 0, 0.035);
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  color: #667487;
  font-size: 10px;
  line-height: 1;
  overflow: hidden;
  padding: 0 3px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remoteChannelAdd {
  align-items: center;
  background: #f7f9fc;
  border: 1px solid #d8e0ea;
  border-radius: 6px;
  color: #27364a;
  display: flex;
  flex: 0 0 36px;
  font-size: 20px;
  font-weight: 700;
  height: 52px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  width: 36px;
}

.remoteChannelAdd:hover:not(:disabled) {
  background: #eef6ff;
  border-color: #6fb1ff;
}

.remoteChannelAdd:disabled {
  opacity: 0.55;
}

.remoteChannelButton:hover:not(:disabled) {
  background: rgba(45, 140, 255, 0.08);
}

.remoteServerButton:hover:not(:disabled) {
  background: #e8f1ff;
  color: #176bc2;
}

.remoteChannelLive {
  background: #ecfff3;
  border-color: #74c98c;
  box-shadow: inset 0 0 0 1px rgba(38, 166, 91, 0.18);
}

.remoteChannelLive .remoteChannelButton {
  color: #167341;
}

.remoteChannelSelected {
  background: #eef6ff;
  border-color: #6fb1ff;
}

.remoteServerSelected {
  background: #e8f1ff;
  color: #176bc2;
  font-weight: 700;
}

.remoteChannelDisabled {
  opacity: 0.62;
}

.remoteSectionDivider {
  border: 0;
  border-top: 1px solid #e4e8ee;
  margin: 0;
}

.remoteBottomActions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-start;
  margin-top: 14px;
  margin-bottom: 18px;
}

.remotePlayerChannel {
  background: #eef6ff;
  border: 1px solid #6fb1ff;
  border-radius: 6px;
  display: grid;
  flex: 0 0 56px;
  grid-template-rows: 30px 20px;
  min-height: 52px;
  min-width: 56px;
  overflow: hidden;
  text-align: center;
}

.remotePlayerChannelButton,
.remotePlayerChannelLabel {
  align-items: center;
  background: transparent;
  border: 0;
  color: inherit;
  display: flex;
  justify-content: center;
  margin: 0;
  width: 100%;
}

.remotePlayerChannelButton {
  color: #176bc2;
  font-size: 13px;
  font-weight: 700;
  padding: 0 4px;
}

.remotePlayerChannelLabel {
  background: #dfefff;
  border-top: 1px solid rgba(23, 107, 194, 0.18);
  color: #176bc2;
  font-size: 10px;
  line-height: 1;
  overflow: hidden;
  padding: 0 3px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remotePlayerChannel:hover {
  background: #dfefff;
  border-color: #2f80ed;
}

.remotePlayerChannelButton:hover,
.remotePlayerChannelLabel:hover {
  background: rgba(45, 140, 255, 0.08);
}

.remotePlayerChannelExtra {
  background: #f7f9fc;
  border-color: #d8e0ea;
}

.remotePlayerChannelExtra .remotePlayerChannelButton {
  color: #27364a;
}

.remotePlayerChannelExtra .remotePlayerChannelLabel {
  background: rgba(0, 0, 0, 0.035);
  border-top-color: rgba(0, 0, 0, 0.08);
  color: #667487;
}

.remotePlayerChannelExtra:hover {
  background: #eef2f6;
  border-color: #b9c4d0;
}

.remoteServerOption {
  margin: 4px;
}

@media (max-width: 768px) {
  .remoteStatusMenu {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }

  .remoteSourceLayout {
    grid-template-columns: 1fr;
  }

  .remoteFavoritesPanel {
    border-right: 0;
    border-bottom: 1px solid #e4e8ee;
    padding: 0 0 14px;
  }
}
</style>
